// SPDX-License-Identifier: AGPL-3.0-or-later
import type {AgentConnection, AgentMachineView, AgentModel} from '@fluxer/schema/src/domains/konvo/Agents';

/** The new bridge reports the configured inventory, independently of executable models. */
export function machineConnections(machine: Pick<AgentMachineView, 'tools'> | null): Array<AgentConnection> {
	return machine?.tools.flatMap((tool) => tool.connections ?? []) ?? [];
}

export function visibleModels(machine: Pick<AgentMachineView, 'tools'> | null): Array<AgentModel> {
	const models = new Map<string, AgentModel>();
	for (const model of [
		...machineConnections(machine).flatMap((c) => c.models),
		...(machine?.tools.flatMap((t) => t.models ?? []) ?? []),
	])
		models.set(`${model.provider}\n${model.model}`, model);
	return [...models.values()];
}

export function connectionNeedsAttention(connection: AgentConnection, now: number): boolean {
	return (
		(connection.status !== 'ready' && connection.status !== 'disabled') ||
		(connection.status === 'ready' &&
			!!connection.loginExpiresAt &&
			Date.parse(connection.loginExpiresAt) <= now + 3 * 86400_000)
	);
}
